import { WhichWeightAPI } from 'WhichWeightAPI'
import { useState, useContext } from 'react'
import { useSelector } from 'react-redux'
import { WeekOfTheYearKey } from 'classes/WeekOfTheYearKey'
import { ModalContext } from '../ModalContext'
import moment from 'moment'

import KinesisProgramWeekKeyIcon from 'components/Athlete/v2/KinesisProgramWeeks/KinesisProgramWeekKeyIcon'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function ProgramWeekInfoModal() {

    const { modalData, HideModal } = useContext(ModalContext)

    const profileType = useSelector(state => state.athleteProfile.profileType)
    const groupId = useSelector(state => state.athleteProfile.groupId)
    const athleteId = useSelector(state => state.athleteProfile.userId)
    const trainingChartActiveData = useSelector(state => state.athleteProfile.activeData)

    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const OnSkipWeekButton = async () => {

        setErrorMessage('')

        if (new WeekOfTheYearKey(modalData.weekOfTheYearKey).equals(new WeekOfTheYearKey(trainingChartActiveData.weekOfTheYearKey)) === false) {
            setErrorMessage("Cannot skip this week. Only the present week can be skipped.")
            return
        }

        if (
            trainingChartActiveData.completionData['strength-session-a'].completed === true
            || trainingChartActiveData.completionData['strength-session-b'].completed === true
        ) {
            setErrorMessage("Unable to skip week with completed strength sessions")
            return
        }


        if (profileType === 'group') {
            setIsLoading(true)

            const jsonBody = {
                groupId: groupId,
                weekOfTheYearKey: modalData.weekOfTheYearKey,
                localDate: moment.utc().local().format('YYYY-MM-DD'),
            }

            // console.log(jsonBody)
            
            const result = await WhichWeightAPI('PROGRAM', 'POST', '/group_training_chart_skip_program_week', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                setIsLoading(false)
                setErrorMessage("Unable to skip week. Please try again.")
                return
            }
        }

        if (profileType === 'individual') {
            setIsLoading(true)

            const jsonBody = {
                userId: athleteId,
                weekOfTheYearKey: modalData.weekOfTheYearKey,
            }

            // console.log(jsonBody)
            
            const result = await WhichWeightAPI('PROGRAM', 'POST', '/training_chart_skip_program_week', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                setIsLoading(false)
                setErrorMessage("Unable to skip week. Please try again.")
                return
            }
        }
        
        modalData.RefreshCalendarData()

        setIsLoading(false)
        HideModal()
    }

    const OnUndoSkipWeekButton = async () => {

        if (profileType === 'group') {
            setIsLoading(true)

            const jsonBody = {
                groupId: groupId,
                weekOfTheYearKey: modalData.weekOfTheYearKey,
                localDate: moment.utc().local().format('YYYY-MM-DD'),
            }

            // console.log(jsonBody)
            
            const result = await WhichWeightAPI('PROGRAM', 'POST', '/group_training_chart_undo_skip_program_week', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                setIsLoading(false)
                return
            }
        }

        if (profileType === 'individual') {
            setIsLoading(true)

            const jsonBody = {
                userId: athleteId,
                weekOfTheYearKey: modalData.weekOfTheYearKey
            }

            // console.log(jsonBody)
            
            const result = await WhichWeightAPI('PROGRAM', 'POST', '/training_chart_undo_skip_program_week', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                setIsLoading(false)
                return
            }
        }

        modalData.RefreshCalendarData()

        setIsLoading(false)
        HideModal()
    }

    if (modalData === null || trainingChartActiveData === null) return null
    
    return (
        <>
            <div className='space-y-1'>
                <div className='text-xs text-gray-500'>{modalData.weekOfTheYearKey}</div>
                <div className="text-center font-semibold leading-6 text-gray-900">{new WeekOfTheYearKey(modalData.weekOfTheYearKey).toDateRangeString('MMMM D, YYYY')}</div>
            </div>

            <div className='flex items-center justify-center gap-2'>
                <KinesisProgramWeekKeyIcon programWeekKey={modalData.programWeekKey} />
                
                <div className='pb-0.5'>
                    {modalData.programWeekKey
                        ?.split('-')
                        .map(str => str.charAt(0).toUpperCase() + str.slice(1))
                        .join(' ')
                    }
                </div>
            </div>

            {trainingChartActiveData.weekCompletionStatusKey !== 'skipped' && (
                <BrandColorButton
                    text={'Skip Week'}
                    isLoading={isLoading}
                    action={OnSkipWeekButton}
                />
            )}

            {trainingChartActiveData.weekCompletionStatusKey === 'skipped' && (
                <BrandColorButton
                    text={'Undo Skipped Week'}
                    isLoading={isLoading}
                    action={OnUndoSkipWeekButton}
                />
            )}

            {errorMessage !== '' && (
                <div className='text-center text-xs font-bold text-red-500'>{errorMessage}</div>
            )}
        </>
    )
}
